import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";

const WithReact = () => {
  return (
    <div className="react-page">
      <div className="react-container">
        <h1 className="title">
          Here the magic of typescript come and now the time to practice the
          basics 🚀
        </h1>
        <div className="img-container">
          <img
            src="./img/react_ts.png"
            alt="react+ts"
            className="react-image"
          />
        </div>

        <p>
          First of all If you’re building a new app and using create-react-app,
          the Create React App docs are great, but with typescript this is
          secret key 😉😜 : <br />
          <code
            style={{
              display: "block",
              textAlign: "center",
              margin: "20px auto",
            }}
          >
            npx create-react-app my-app --template typescript
          </code>
        </p>
        <p>
          <b>&#8594; In this section</b>, we'll explore together five key
          examples of integrating TypeScript with React, covering some of the
          most practical applications.In this section we will implement together
          five principle examples of typescript with react and it's athe almost
          uses 😉
        </p>

        <h2>1-Props</h2>
        <p>
          In this example we will take a simple example that we define a &nbsp;
          <code>{`<PostList />`}</code> page and we pass into it a&nbsp;
          <code>{`<PostCard />`}</code> components and we need to pass some
          props that we will fetched from an Api and I choose for example the
          <code>https://jsonplaceholder.typicode.com</code>
          <br />
          This is The expected result :
        </p>
        <div className="box">
          <div className="laptop">
            <img src="/img/laptop.png" alt="laptop" />
            <div className="laptopScreen">
              <img
                src="img/props.png"
                alt="props-img"
                className="laptopPhoto"
              />
            </div>
          </div>
          <div className="icons">
            <button className="liendesite">
              <Link to={"/getdata"} className="link">
                <FontAwesomeIcon icon={faEye} size="lg" />
              </Link>
            </button>

            <button className="github">
              <a
                href="https://github.com/ayma5001/TypeScript10/tree/master/src/pages"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faGithub} size="lg" />
              </a>
            </button>
          </div>
        </div>

        <p>
          In this part you need to focus about all the types and to respect this
          issue I define under the <code>{"/src"}</code> a &nbsp;
          <code>{"/types"}</code> folder to define the props types (string,
          boolean, number , etc...)
        </p>

        <p>
          <b>&#8594; Notice also </b>In React with TypeScript, <code>FC</code>
          stands for Functional Component. It's a type definition provided by
          the React library that you can use to type your functional components.
          It provides built-in types for common properties like children, props,
          and others, making it easier to work with components in a strongly
          typed environment. When you use FC (or FunctionComponent, which is the
          same but more verbose), you can define the props your component
          expects. Here’s a basic example:
        </p>
        <img src="/img/r1.png" alt="fc-example" className="image moy" />

        <h2>2-Events</h2>

        <p>
          In this part you will see almost events (buttons , inputs, etc...)
          it's very simple all you need is to hover over the button for example
          and the magic type will appear 😉😋. <br />
          in this example I will show you how to define the onClick event for
          example , all you need is to open my github repository and read the
          code step by step it's very simple belive me !! 😉😎💪
        </p>

        <div className="box">
          <div className="laptop">
            <img src="/img/laptop.png" alt="laptop" />
            <div className="laptopScreen">
              <img
                src="img/event.png"
                alt="event-img"
                className="laptopPhoto"
              />
            </div>
          </div>
          <div className="icons">
            <button className="liendesite">
              <Link to={"/event"} className="link">
                <FontAwesomeIcon icon={faEye} size="lg" />
              </Link>
            </button>

            <button className="github">
              <a
                href="https://github.com/ayma5001/TypeScript10/tree/master/src/pages"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faGithub} size="lg" />
              </a>
            </button>
          </div>
        </div>

        <h2>3-UseState</h2>

        <p>
          <b>&#8594; useState: </b> in TypeScript is a Hook that lets you add
          state to functional components, with optional type annotation for
          state management.
        </p>

        <p>
          In this example I will give you a simple example to handle the
          useState with typeScript , it's just a signin form
        </p>

        <p>
          <b>&#8594; Just follow the code and it's very simple </b> you can try
          it also live just click to the eye button 😁😊
        </p>

        <div className="box">
          <div className="laptop">
            <img src="/img/laptop.png" alt="laptop" />
            <div className="laptopScreen">
              <img
                src="img/useState.png"
                alt="event-img"
                className="laptopPhoto"
              />
            </div>
          </div>
          <div className="icons">
            <button className="liendesite">
              <Link to={"/usestate"} className="link">
                <FontAwesomeIcon icon={faEye} size="lg" />
              </Link>
            </button>

            <button className="github">
              <a
                href="https://github.com/ayma5001/TypeScript10/tree/master/src/pages"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faGithub} size="lg" />
              </a>
            </button>
          </div>
        </div>

        <h2>4-UseRef</h2>
        <p>
          <b>&#8594; useRef </b> in TypeScript provides a way to access and
          interact with DOM elements or store mutable values across renders,
          with type annotation for the reference object.
        </p>

        <p>
          <b>&#8594; Notice also that</b> useRef is for accessing DOM elements
          and persisting values without causing rerenders, while useState is for
          managing state in a component with automatic rerenders on state
          changes.
        </p>

        <p>
          In this example I want that everytime I open the page the cursor will
          focus on the <b>first input</b> , and for the <b>second input</b> is
          to hold the data entered , as simple as that hhhh 😊😉
        </p>

        <div className="box">
          <div className="laptop">
            <img src="/img/laptop.png" alt="laptop" />
            <div className="laptopScreen">
              <img
                src="img/useRef.png"
                alt="event-img"
                className="laptopPhoto"
              />
            </div>
          </div>
          <div className="icons">
            <button className="liendesite">
              <Link to={"/useref"} className="link">
                <FontAwesomeIcon icon={faEye} size="lg" />
              </Link>
            </button>

            <button className="github">
              <a
                href="https://github.com/ayma5001/TypeScript10/tree/master/src/pages"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faGithub} size="lg" />
              </a>
            </button>
          </div>
        </div>

        <h2>5-UseContext</h2>

        <p>
          <b>&#8594; It's the most complicated part</b> but dont worry there is
          no problem 😎🐱‍🏍 , let's start, useContext allows you to access and
          subscribe to React context values in functional components without
          needing a consumer.
        </p>

        <p>
          In this example I will show you how to change the theme from a state
          to another also how to change the font from a size to another lets
          start
        </p>

        <p>
          First of all you need to define under the <code>{"/src"}</code> a
          &nbsp;
          <code>{"/context"}</code> folder to define the themeContext elements
          (reducer, actions,etc...)
        </p>

        <p>
          <b>&#8594; Notice that</b> you need to define each type of your state
          before, also there is a very important thing here is to define the
          dispatch function like that{" "}
          <code>{"dispatch: React.Dispatch<ActionType>"}</code> , ActionType is
          the type of your actions , just follow the code in my github, and you
          will get everything!! 😉
          <b>also there is another last note</b> , to pass children in react
          with typeScript we need to define the type for these children like
          that <code>{"children:React.ReactNode"}</code>
        </p>

        <div className="box">
          <div className="laptop">
            <img src="/img/laptop.png" alt="laptop" />
            <div className="laptopScreen">
              <img
                src="img/useContext.png"
                alt="event-img"
                className="laptopPhoto"
              />
            </div>
          </div>
          <div className="icons">
            <button className="liendesite">
              <Link to={"/useContext"} className="link">
                <FontAwesomeIcon icon={faEye} size="lg" />
              </Link>
            </button>

            <button className="github">
              <a
                href="https://github.com/ayma5001/TypeScript10/tree/master/src/pages"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faGithub} size="lg" />
              </a>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithReact;
